export default __webpack_public_path__ + "static/media/gremlin-logo-primary.5532dbdaed611e663293c375066ac2b3.svg";